import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { DispatchHelpers as AssetMonitoringDispatchHelpers, Selectors as AssetMonitoringSelectors } from '../../../../../data/assetMonitoring';

import ResourceGroup from '../ResourceGroup';
import Protected from '../../../../common/protected';
import Asset from './Asset';
import { setSelectedResource } from '../../actions';
import { strings } from '../../../../../localization';


class Assets extends React.PureComponent {

    componentDidMount() {
        // this check won't be needed with new model, as assets and beacons will be loaded in dashboard
        // if (this.props.assetUuids.length === 0) {
        //     this.props.loadBeacons(this.props.stage);
        // }
    }

    componentDidUpdate(prevProps) {
        // console.log("RAV-5191 POC component update", this.props.assetsPending, this.props.assets, this.props.beacons);
    };

    refreshAssets = () => {
        this.props.loadAssets()
        .catch((err) => {
            console.error("Error refreshing assets", err);
            // Error message will be shown in ResourceGroup via props.assetsErrorMessage
            // See the render return statement below
        });
    }

    setVisible = (assetUuid, visible) => {
        this.props.setAssetVisible(assetUuid, visible);
        this.props.pokeMap();
    }

    setAllVisible = (type, visible) => {
        this.props.setAllAssetsVisible(visible);
        this.props.pokeMap();
    }

    addNewAsset = () => {
        if (this.props.assetEditModeActive) {
            console.error('addNewAsset called while assetEditModeActive');
            return;
        }

        this.props.addNewAsset();
        this.props.setDetailPanelOpen(true);
    }

    render() {
        const {
            assetUuids,
            limit,
            assetEditModeActive,
            assetVisibilityForId,
            assetNameForId,
            ...rest
        } = this.props;

        const footer = (
            <>
            <button data-testid="refresh-assets-button" disabled={assetEditModeActive || this.props.loading} className='btn btn-outline-blue btn-sm mr-1' onClick={this.refreshAssets}>
                <i className="material-icons">refresh</i>{strings.resource_group_refresh_assets}
            </button>

            <Protected resource="assets" action="write" gate={!limit || limit > assetUuids.length} >
                <button data-testid="add-asset-button" disabled={assetEditModeActive || this.props.loading} className='btn btn-blue btn-sm' onClick={this.addNewAsset}>
                    {strings.resource_group_add_asset}
                </button>
            </Protected>
            </>

        );

        return (
            <ResourceGroup
                {...rest}
                type='asset'
                items={assetUuids}
                setAllVisible={this.setAllVisible}
                setVisible={this.setVisible}
                itemFactory={itemFactory}
                footer={footer}
                footerHeight={26}
                renderEmptyList={true}
                assetVisibilityForId={assetVisibilityForId}
                assetNameForId={assetNameForId}
                listErrorMessage={this.props.assetsErrorMessage ? strings.resource_group_assets_error : null}
            />
        );
    }

}

Assets.propTypes = {
    addNewAsset: PropTypes.func.isRequired,
    assetEditModeActive: PropTypes.bool.isRequired,
    assetUuids: PropTypes.array.isRequired,
    limit: PropTypes.number,
    loadAssets: PropTypes.func.isRequired, // won't be needed with new model
    // loadBeacons: PropTypes.func.isRequired, // won't be needed with new model
    loading: PropTypes.bool.isRequired,
    pokeMap: PropTypes.func.isRequired,
    setAllAssetsVisible: PropTypes.func.isRequired,
    setAssetVisible: PropTypes.func.isRequired,
    setDetailPanelOpen: PropTypes.func.isRequired,
    stage: PropTypes.string.isRequired,
};


const itemFactory = (it, props) => (
    <Asset
        key={it}
        stage={props.stage}
        assetUuid={it}
        editingName={props.editingNameFor === it}
        onSelectResource={props.onSelectResource}
        selected={props.selectedId === it}
        setVisible={props.setVisible}
        setEditingItemName={props.setEditingItemName}
        editable={props.user?.permissions?.includes('assets_and_beacons')}
        onError={props.onError}
    />
);

const mapStateToProps = (state, ownProps) => {
    return {
        assetUuids: AssetMonitoringSelectors.assetUuids(state), //assets.Selectors.assetUuids(state),
        loading: AssetMonitoringSelectors.loading(state), //assets.Selectors.loading(state),
        assetVisibilityForId: (assetUuid) => AssetMonitoringSelectors.isAssetVisible(state, assetUuid),
        assetNameForId: (assetUuid) => AssetMonitoringSelectors.assetName(state, assetUuid),
        assets: state.data.assetMonitoring.assets,
        beacons: state.data.assetMonitoring.beacons,
        assetsErrorMessage: state.data.assetMonitoring.assetsErrorMessage,
    };
};

const mapDispatchToProps = {
    //mapboxMap loads assets & beacons already loadAssets: AssetMonitoringDispatchHelpers.loadAssets,//assets.Actions.loadAllAssets, // won't be needed with new model
    loadAssets: AssetMonitoringDispatchHelpers.loadAssets,//beacons.Actions.loadAllBeacons,
    setAssetVisible: AssetMonitoringDispatchHelpers.setAssetVisible,//assets.Actions.setAssetVisible,
    setAllAssetsVisible: AssetMonitoringDispatchHelpers.setAllAssetsVisible,//assets.Actions.setAllAssetsVisible,
    addNewAsset: AssetMonitoringDispatchHelpers.addNewAsset,//assets.Actions.addNewAsset,
    setSelectedResource,
};

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
export { Assets as UnconnectedAssets }; // Added for testing
